"use client";

import { useAtomValue } from "jotai";
import { useTranslations } from "next-intl";
import React, { type ReactElement } from "react";
import { timeserieCountAtom } from "@/store/home";

function HomeStatTimeserie(): ReactElement | null {
  const t = useTranslations("home.StatTimeserie");
  const count = useAtomValue(timeserieCountAtom);

  if (!count) return null;

  return (
    <div className="p-0 flex flex-row gap-2">
      <span className="font-mono text-3xl text-blue-300">{count}</span>
      <span className="text-sm text-blue-500">
        {t("label", { count: count })}
      </span>
    </div>
  );
}

export { HomeStatTimeserie };
